import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { isNilEmpty } from 'Utils'
import { _ShowMore } from './styles'


class ShowMore extends Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.state = {
      showAll: false,
      showingElements: !isNilEmpty(props.elements) ? props.elements.slice(0, props.minShow) : [],
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.elements !== this.props.elements) {
      // eslint-disable-next-line
      this.setState({
        showingElements: !isNilEmpty(this.props.elements) ?
          (this.state.showAll ? this.props.elements : this.props.elements.slice(0, this.props.minShow)) : [],
      })
    }
  }
  handleClick() {
    const { elements, minShow } = this.props
    const showingElements = this.state.showAll ? (
      elements ? elements.slice(0, minShow) : []
    ) : this.props.elements
    this.setState({
      showingElements,
      showAll: !this.state.showAll,
    })
  }
  render() {
    const {
      elements, minShow,
      btnClass, disableShowLess = false,
      showCount, dividerElem = '',
      className = '',
    } = this.props

    const { showingElements } = this.state

    const showAll = this.state.showAll
    let showButton = (elements && elements.length > minShow)
    let buttonText = showAll ? 'Show Less' : this.props.buttonText

    if(showCount && showButton) {
      buttonText = `${elements.length - 4} ${buttonText}`
    }

    if(showAll && disableShowLess) {
      showButton = false
    }
    return (
      <Fragment>
        {
          this.state.showingElements.map((elem, index) => {
            if(dividerElem) {
              return (
                //  eslint-disable-next-line
                <div key={index + className}>
                  {elem}
                  {showingElements && index < showingElements.length - 1 ? dividerElem : ''}
                </div>
              )
            }
            return elem
          })
        }
        {
          showButton && (
            <_ShowMore
              className={className}
              hide={!!btnClass}
              onClick={this.handleClick}
            >
              {elements.length > minShow && buttonText}
            </_ShowMore>
          )
        }
      </Fragment>
    )
  }
}

ShowMore.propTypes = {
  buttonText: PropTypes.string,
  btnClass: PropTypes.string,
  className: PropTypes.string,
  minShow: PropTypes.number,
  showCount: PropTypes.bool,
  disableShowLess: PropTypes.bool,
  elements: PropTypes.arrayOf(PropTypes.element).isRequired,
  dividerElem: PropTypes.node,
}

export default ShowMore
